import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const offer = document.getElementById('offer');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const offerTop = offer ? offer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      setVisible(heroBottom < 0 && offerTop >= window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-70" data-mp="38bgxrs7yhfwg">
      {visible}
    </AnimatePresence>;
}